module.exports = __webpack_public_path__ + "img/icon-estrella-set.b5836e0a.svg";